export default function getCroppedImg(imageSrc, pixelCrop) {
  console.log("getCroppedImg called with:", { imageSrc, pixelCrop });
  
  return new Promise((resolve, reject) => {
    if (!imageSrc || !pixelCrop) {
      reject(new Error("Missing imageSrc or pixelCrop"));
      return;
    }

    const image = new Image();
    image.crossOrigin = "anonymous";

    image.onload = () => {
      console.log("Source image loaded for cropping:", image.width, "x", image.height);
      
      try {
        const canvas = document.createElement("canvas");
        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;

        const ctx = canvas.getContext("2d");
        
        console.log("Cropping with parameters:", {
          sourceX: pixelCrop.x,
          sourceY: pixelCrop.y,
          sourceWidth: pixelCrop.width,
          sourceHeight: pixelCrop.height,
          destWidth: pixelCrop.width,
          destHeight: pixelCrop.height
        });

        // Draw the cropped portion of the image
        ctx.drawImage(
          image,
          pixelCrop.x,
          pixelCrop.y,
          pixelCrop.width,
          pixelCrop.height,
          0,
          0,
          pixelCrop.width,
          pixelCrop.height
        );

        // Convert canvas to blob and return URL
        canvas.toBlob((blob) => {
          if (!blob) {
            console.error("Failed to create blob from canvas");
            reject(new Error("Canvas is empty - failed to create blob"));
            return;
          }
          
          console.log("Blob created successfully, size:", blob.size);
          const fileUrl = URL.createObjectURL(blob);
          console.log("Cropped image URL created:", fileUrl);
          resolve(fileUrl);
        }, "image/png", 1.0); // Use PNG for better quality
        
      } catch (error) {
        console.error("Error during canvas operations:", error);
        reject(error);
      }
    };

    image.onerror = (error) => {
      console.error("Failed to load source image:", error);
      reject(new Error(`Failed to load image: ${error.message || error}`));
    };

    image.src = imageSrc;
    console.log("Image src set to:", imageSrc);
  });
}